import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, message, Row } from 'antd'
import { saveAs } from "file-saver"
import XlsxPopulate from "xlsx-populate"
import Utils from '../../../../utils/Utils'
import GenericSelect from '../../../../components/GenericSelect'
import downloadSrc from './downloadSrc'
import storeChainSrc from '../../../storeChains/storeChainSrc'

function DescargaTab(props) {
  const [company_id, setCompanyId] = useState(null)
  const [store_chains, setStoreChains] = useState([])
  const [store_chain_id, setStoreChainId] = useState(null)
  const [itemId, setItemId] = useState(null)

  useEffect(() => {
    if (props.keyTab === '6') {
      onSearchStoreChain()
    }
    // eslint-disable-next-line
  }, [props.keyTab])

  const onSearchStoreChain = val => {
    val !== null ? (val = '') : (val = '')

    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreChainOption(val, excludeChars, 'desc')
      .then(response => {
        setStoreChains(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de la Cadena')
      })
  }

  const getSheetData = (data, header) => {
    const fields = Object.keys(data[0]);
    const sheetData = data.map(row => {
      return fields.map(fieldName => {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  const saveAsExcel = async () => {
    const readByStoreChainId = await storeChainSrc.readByStoreChainId(store_chain_id)
    const today = new Date().toLocaleDateString("en-US")
    let excel = []
    let nombreData = ''
    let storeChainName = readByStoreChainId.name

    switch (itemId) {
      case 0:
        const getProductCsv = await downloadSrc.getProductCsv(store_chain_id)
        getProductCsv.data.forEach(element => {
          if (element.is_all_countries === 0) {
            element.is_all_countries = '0'
          }
          if (element.is_taxable === 0) {
            element.is_taxable = '0'
          }
          if (element.is_inventoriable === 0) {
            element.is_inventoriable = '0'
          }
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getProductCsv
        nombreData = 'Productos'

        break;
      case 1:
        const getPresentationCsv = await downloadSrc.getPresentationCsv(store_chain_id)
        getPresentationCsv.data.forEach(element => {
          if (element.is_grouping === 0) {
            element.is_grouping = '0'
          }
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getPresentationCsv
        nombreData = 'Presentaciones'

        break;
      case 2:
        const getDiscountsCsv = await downloadSrc.getDiscountsCsv(company_id)
        getDiscountsCsv.data.forEach(element => {
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getDiscountsCsv
        nombreData = 'Descuentos'

        break;
      case 3:
        const getSkuCsv = await downloadSrc.getSkuCsv(store_chain_id)
        getSkuCsv.data.forEach(element => {
          if (element.seasonal_product === 0) {
            element.seasonal_product = '0'
          }
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getSkuCsv
        nombreData = 'Skus'

        break;
      case 4:
        const getCombosCsv = await downloadSrc.getCombosCsv(company_id)
        getCombosCsv.data.forEach(element => {
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getCombosCsv
        nombreData = 'Combos'

        break;
      case 5:
        const getPresentationDiscountCsv = await downloadSrc.getPresentationDiscountCsv(company_id)
        getPresentationDiscountCsv.data.forEach(element => {
          if (element.deleted_at === null) {
            element.deleted_at = 'null'
          }
        });
        excel = getPresentationDiscountCsv
        nombreData = 'PresentacionesDescuentos'

        break;
      default:
        break;
    }

    if (excel.data.length > 0) {
      const data = excel.data
      const header = Object.keys(data[0])

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const sheetData = getSheetData(data, header);
        const totalColumns = sheetData[0].length;

        sheet1.cell("A1").value(sheetData);
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);
        sheet1.row(1).style("bold", true);
        sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
        sheet1.column("c").width(25)
        range.style("border", true);
        return workbook.outputAsync().then((res) => {
          saveAs(res, `${nombreData}-${storeChainName}-${today}` + ".xlsx");
        });
      });
    } else {
      message.error(`No posee ${nombreData}`)
    }
  }

  const items = [
    { id: 0, name: 'Productos' },
    { id: 1, name: 'Presentaciones' },
    { id: 2, name: 'Niveles de descuento' },
    { id: 3, name: 'Skus' },
    { id: 4, name: 'Combos' },
    { id: 5, name: 'Presentaciones con niveles de descuento' },
  ]

  return (
    <>
      <Row gutter={16}>
        <Col xs={9} sm={9} md={9} lg={9}>
          <GenericSelect
            data={store_chains}
            value={(props.edit || store_chain_id !== '') && store_chain_id !== 0 ? store_chain_id : ''}
            handlerChange={value => setStoreChainId(value)}
            placeholder={'Elegir Cadena'}
            disabled={props.edit || !store_chains}
          />
        </Col>
        <Col xs={9} sm={9} md={9} lg={9}>
          <GenericSelect
            data={items}
            value={itemId}
            handlerChange={value => setItemId(value)}
            placeholder={'Elegir datos'}
            disabled={!store_chain_id}
          />
        </Col>
        <Col xs={6} sm={6} md={6} lg={6}>
          {true &&
            <Button disabled={store_chain_id === null || itemId === null} style={{ width: '100%', height: '100%', color: 'var(--tendero-green)', background: '#ddefe8', border: '#cdcdcd' }} className={'new-deposit'} onClick={saveAsExcel}>
              Descargar CSV
            </Button>
          }
        </Col>
      </Row>
    </>
  )
}

export default DescargaTab
